import {
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'

// const baseUrl = 'http://localhost:3001'
const baseUrl =
  'https://king-prawn-app-ugsdt.ondigitalocean.app'

export const digitalAppApi = createApi({
  reducerPath: 'digitalAppApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    //SUppliers credentials
    getSuppliersCredentials: builder.query({
      query: () => ({
        url: `/api/debtors-supp`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: (result, error, id) => [
        { type: 'SupCredentials', id: id },
      ],
    }),
    getSuppliersCredentialsById: builder.query({
      query: (id) => ({
        url: `/api/debtors-supp/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: (result, error, id) => [
        { type: 'SupCredentials', id: id },
      ],
    }),
    updateSuppliersCredentialsById: builder.mutation({
      query: (body) => ({
        url: `/api/debtors-supp/${body.id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
        body: body.data,
      }),
      invalidatesTags: ['SupCredentials'],
    }),
    deleteSuppliersCredentialsById: builder.mutation({
      query: (id) => ({
        url: `/api/debtors-supp/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      }),
      invalidatesTags: ['SupCredentials'],
    }),
    CreateSuppliersCredentials: builder.mutation({
      query: (body) => ({
        url: '/api/debtors-supp',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['SupCredentials'],
    }),

    getMeetings: builder.query({
      query: (query) => ({
        url: `/api/meetings`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          limit: query.limit || 9999,
          search: query.search || '',
        },
      }),
      providesTags: (result, error, id) => ['Meetings'],
    }),
    getMeetingsById: builder.query({
      query: (id) => ({
        url: `/api/meetings/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: (result, error, id) => ['Meetings'],
    }),
    updateMeetingsById: builder.mutation({
      query: (body) => ({
        url: `/api/meetings/${body.id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
        body: body.data,
      }),
      invalidatesTags: ['Meetings'],
    }),
    deleteMeetingsById: builder.mutation({
      query: (id) => ({
        url: `/api/meetings/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      }),
      invalidatesTags: ['Meetings'],
    }),
    CreateMeetings: builder.mutation({
      query: (body) => ({
        url: '/api/meetings',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Meetings'],
    }),

    getAlbaranById: builder.query({
      query: (params) => {
        const { id, tradeName } = params || {}
        const queryParams = new URLSearchParams()

        if (tradeName)
          queryParams.append('tradeName', tradeName)

        const queryString = queryParams.toString()
        const url = `/api/print-document/albaran/${id}${
          queryString ? `?${queryString}` : ''
        }`

        return {
          url,
          headers: {
            'Content-Type': 'application/pdf',
          },
          method: 'GET',
          responseHandler: async (response) => {
            if (!response.ok) {
              // Читаем текст ошибки
              throw new Error(
                (await response.text()) ||
                  `HTTP error! Status: ${response.status}`,
              )
            }
            // 💡 ЭТО КРИТИЧНО: Если 200 OK, возвращаем Blob
            return response.blob()
          },
        }
      },
    }),
    getCheckListById: builder.query({
      query: (params) => {
        const { id, tradeName } = params || {}
        const queryParams = new URLSearchParams()

        if (tradeName)
          queryParams.append('tradeName', tradeName)

        const queryString = queryParams.toString()
        const url = `/api/print-document/checklist/${id}${
          queryString ? `?${queryString}` : ''
        }`

        return {
          url,
          headers: {
            'Content-Type': 'application/pdf',
          },
          method: 'GET',
          responseHandler: async (response) => {
            if (!response.ok) {
              // Читаем текст ошибки
              throw new Error(
                (await response.text()) ||
                  `HTTP error! Status: ${response.status}`,
              )
            }
            // 💡 ЭТО КРИТИЧНО: Если 200 OK, возвращаем Blob
            return response.blob()
          },
        }
      },
    }),
    getInvoiceById: builder.query({
      query: (params) => {
        const {
          orderId,
          accountKey,
          number,
          numberInYear,
          orderIds,
          date,
          tradeName,
        } = params || {}
        const queryParams = new URLSearchParams()

        if (accountKey)
          queryParams.append('accountKey', accountKey)
        if (number) queryParams.append('number', number)
        if (numberInYear)
          queryParams.append('numberInYear', numberInYear)
        if (orderIds)
          queryParams.append('orderIds', orderIds)
        if (date) queryParams.append('date', date)
        if (tradeName)
          queryParams.append('tradeName', tradeName)

        const queryString = queryParams.toString()
        const url = orderId
          ? `/api/print-document/invoice/${orderId}${queryString ? `?${queryString}` : ''}`
          : `/api/print-document/invoice/any${queryString ? `?${queryString}` : ''}`

        return {
          url,
          headers: {
            'Content-Type': 'application/pdf',
          },
          method: 'GET',
          responseHandler: async (response) => {
            if (!response.ok) {
              // Читаем текст ошибки
              throw new Error(
                (await response.text()) ||
                  `HTTP error! Status: ${response.status}`,
              )
            }
            // 💡 ЭТО КРИТИЧНО: Если 200 OK, возвращаем Blob
            return response.blob()
          },
        }
      },
    }),
    getInvoiceDetailed: builder.query({
      query: (params) => {
        const {
          accountKey,
          orderIds,
          number,
          numberInYear,
          date,
          tradeName,
        } = params || {}
        const queryParams = new URLSearchParams()

        if (accountKey)
          queryParams.append('accountKey', accountKey)
        if (orderIds)
          queryParams.append('orderIds', orderIds)
        if (number) queryParams.append('number', number)
        if (numberInYear)
          queryParams.append('numberInYear', numberInYear)
        if (date) queryParams.append('date', date)
        if (tradeName)
          queryParams.append('tradeName', tradeName)

        const queryString = queryParams.toString()

        return {
          url: `/api/print-document/invoice-detailed${queryString ? `?${queryString}` : ''}`,
          headers: {
            'Content-Type': 'application/pdf',
          },
          method: 'GET',
          responseHandler: async (response) => {
            if (!response.ok) {
              // Читаем текст ошибки
              throw new Error(
                (await response.text()) ||
                  `HTTP error! Status: ${response.status}`,
              )
            }
            // 💡 ЭТО КРИТИЧНО: Если 200 OK, возвращаем Blob
            return response.blob()
          },
        }
      },
    }),
    updateContactStatus: builder.mutation({
      query: (body) => ({
        url: `/api/contacts/${body.id}/status`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
        body: {
          status: body.status,
        },
      }),
    }),
    deleteDatabaseStatus: builder.mutation({
      query: (body) => ({
        url: `/api/statuses/${body.id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      }),
    }),

    // CONTACTS

    // Получить список контактов (с фильтрами через params)

    getContacts: builder.query({
      query: (params) => ({
        url: `/api/contacts`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map((c) => ({
                type: 'Contacts',
                id: c._id,
              })),
              { type: 'Contacts', id: 'LIST' },
            ]
          : [{ type: 'Contacts', id: 'LIST' }],
    }),

    // Получить контакт по id
    getContactById: builder.query({
      query: (id) => ({
        url: `/api/contacts/${id}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      // ВАЖНО: добавляем общий LIST‑тег, чтобы можно было
      // рефетчить этот запрос из мутаций (Marco / Personal)
      providesTags: (result, error, id) => [
        { type: 'Contacts', id },
        { type: 'Contacts', id: 'LIST' },
      ],
    }),

    // Создать контакт
    createContact: builder.mutation({
      query: (body) => ({
        url: `/api/contacts`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
      invalidatesTags: [{ type: 'Contacts', id: 'LIST' }],
    }),

    // Обновить контакт
    updateContact: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/api/contacts/${id}`,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Contacts', id },
        { type: 'Contacts', id: 'LIST' },
      ],
    }),

    // Удалить контакт
    deleteContact: builder.mutation({
      query: (id) => ({
        url: `/api/contacts/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: (result, error, id) => [
        { type: 'Contacts', id },
        { type: 'Contacts', id: 'LIST' },
      ],
    }),

    // Получить контакт по tradeName
    getContactByTradeName: builder.query({
      query: (tradeName) => ({
        url: `/api/contacts/trade-name`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params: { tradeName },
      }),
      providesTags: (result) =>
        result?.data?._id
          ? [{ type: 'Contacts', id: result.data._id }]
          : [],
    }),

    // Получить контакт по email
    getContactByEmail: builder.query({
      query: (email) => ({
        url: `/api/contacts/email`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params: { email },
      }),
      providesTags: (result) =>
        result?.data?._id
          ? [{ type: 'Contacts', id: result.data._id }]
          : [],
    }),

    // Получить контакт по phone
    getContactByPhone: builder.query({
      query: (phone) => ({
        url: `/api/contacts/phone`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params: { phone },
      }),
      providesTags: (result) =>
        result?.data?._id
          ? [{ type: 'Contacts', id: result.data._id }]
          : [],
    }),

    // Получить список типов контактов
    getContactTypes: builder.query({
      query: () => ({
        url: `/api/contacts/types`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    // Сменить статус контакта
    changeContactStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `/api/contacts/${id}/status`,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: { status },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Contacts', id },
        { type: 'Contacts', id: 'LIST' },
      ],
    }),

    // Получить статистику контактов
    getContactsStatistics: builder.query({
      query: () => ({
        url: `/api/contacts/statistics`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),
    getContactStatisticsByDate: builder.query({
      query: ({ contactId, startDate, endDate }) => {
        const params = new URLSearchParams()
        if (contactId) params.append('contactId', contactId)
        if (startDate) params.append('startDate', startDate)
        if (endDate) params.append('endDate', endDate)

        return {
          url: `/api/contacts-statistics/by-date?${params.toString()}`,
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'GET',
        }
      },
      providesTags: (result, error, { contactId }) => [
        { type: 'ContactStatisticsByDate', id: contactId },
      ],
    }),

    ////VACATION
    getVacations: builder.query({
      query: (query) => ({
        url: `/api/vacations`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
        params: {
          limit: query.limit || 9999,
          search: query.search || '',
        },
      }),
      providesTags: (result, error, id) => ['Vacation'],
    }),
    getVacationById: builder.query({
      query: (id) => ({
        url: `/api/vacations/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'GET',
      }),
      providesTags: (result, error, id) => ['Vacation'],
    }),
    updateVacationById: builder.mutation({
      query: (body) => ({
        url: `/api/vacations/${body.id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'PATCH',
        body: body.data,
      }),
      invalidatesTags: ['Vacation'],
    }),
    deleteVacationById: builder.mutation({
      query: (id) => ({
        url: `/api/vacations/${id}`,
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'DELETE',
      }),
      invalidatesTags: ['Vacation'],
    }),
    CreateVacation: builder.mutation({
      query: (body) => ({
        url: '/api/vacations',
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Vacation'],
    }),

    // CATALOG
    getCatalog: builder.query({
      query: (params) => ({
        url: `/api/catalog`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params: {
          limit: params?.limit || 50,
          search: params?.search || '',
          sku: params?.sku || '',
        },
      }),
      providesTags: ['Catalog'],
    }),

    getCatalogBySku: builder.query({
      query: (sku) => ({
        url: `/api/catalog/sku`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params: { sku },
      }),
      providesTags: (result, error, sku) => [
        { type: 'Catalog', id: sku },
      ],
    }),

    getCatalogMacro: builder.query({
      query: (query) => ({
        url: `/api/catalog/macro`,
        method: 'GET',
        params: {
          search: query.search || '',
        },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    // MARCO PERSONAL
    // GET /api/contacts/marco-personal?tradeName=BULBA
    // Находит контакт по tradeName
    // Возвращает macroPersonal (или null, если отсутствует)
    getMarcoPersonal: builder.query({
      query: (tradeName) => ({
        url: `/api/contacts/marco-personal`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params: { tradeName },
      }),
      providesTags: (result, error, tradeName) => [
        { type: 'MarcoPersonal', id: tradeName },
      ],
    }),

    // GET /marco-personal/supplier-tradenames - массив tradeName поставщиков с macroPersonal
    getMarcoPersonalSupplierTradenames: builder.query({
      query: () => ({
        url: `/api/contacts/marco-personal/supplier-tradenames`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    // POST /api/contacts/marco-personal?tradeName=BULBA
    // Находит контакт по tradeName
    // Сохраняет macroPersonal из тела запроса
    // Объект может содержать продукты
    addMarcoPersonal: builder.mutation({
      query: ({ tradeName, macroPersonal }) => {
        const queryParams = new URLSearchParams({
          tradeName,
        })
        return {
          url: `/api/contacts/marco-personal?${queryParams.toString()}`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: macroPersonal,
        }
      },
      // После изменения MarcoPersonal рефетчим и сам список Marco,
      // и все запросы, которые завязаны на Contacts LIST (в т.ч. getContactById)
      invalidatesTags: (result, error, { tradeName }) => [
        { type: 'MarcoPersonal', id: tradeName },
        { type: 'Contacts', id: 'LIST' },
      ],
    }),

    // POST /api/admin-base/makro-images/by-codes
    // Body: { codes: string[] }
    // Response: 200, array of { code, imageUrl, url } per requested code
    postMakroImagesByCodes: builder.mutation({
      query: (body) => ({
        url: '/api/admin-base/makro-images/by-codes',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
    }),

    // PERSONAL SALES
    // GET /api/contacts/personal-sales?tradeName=BULBA
    // Находит контакт по tradeName
    // Возвращает personalSales (или null, если отсутствует)
    getPersonalSales: builder.query({
      query: (tradeName) => ({
        url: `/api/contacts/personal-sales`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        params: { tradeName },
      }),
      providesTags: (result, error, tradeName) => [
        { type: 'PersonalSales', id: tradeName },
      ],
    }),

    // POST /api/contacts/personal-sales?tradeName=BULBA
    // Находит контакт по tradeName
    // Сохраняет personalSales из тела запроса
    // Объект может содержать продукты
    addPersonalSales: builder.mutation({
      query: ({ tradeName, personalSales }) => {
        const queryParams = new URLSearchParams({
          tradeName,
        })
        return {
          url: `/api/contacts/personal-sales?${queryParams.toString()}`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: personalSales,
        }
      },
      // Аналогично: обновляем персональные ставки и дергаем все запросы с Contacts LIST
      invalidatesTags: (result, error, { tradeName }) => [
        { type: 'PersonalSales', id: tradeName },
        { type: 'Contacts', id: 'LIST' },
      ],
    }),
  }),
})
